import * as i from 'types';

export const vansForComparingTool = (cars: i.Car[]) => {
  return cars.filter((car) => car.vehicle === 'van' && car.isInVanFinder);
};
